import React, { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import HelmetWrapper from 'components/HelmetWrapper';
import DataRoomContext from '../../providers/DataRoom/DataRoom.context';
import { useTranslation } from 'react-i18next';
import { getDataRoomRoute } from 'utils';

const MembersRouter: React.FC = () => {
  const {
    isAdmin,
    dataRoom: { _id, name },
  } = useContext(DataRoomContext);
  const { t } = useTranslation();

  if (!isAdmin)
    return <Navigate to={getDataRoomRoute(_id, 'documents')} replace />;

  return (
    <>
      <HelmetWrapper title={`${t('dataRoomMembers')} - ${name}`} />
      <Outlet />
    </>
  );
};

export default MembersRouter;
